import {
  finAppStatusConstants,
  httpVerbConstants,
} from '../constants/actionTypes'
import { FetchFinAppStatusService } from '../services/finAppStatusService'
import { FinAppStatusValue } from 'application/utils/type'

const finAppStatusRequest = () => ({
  type: finAppStatusConstants.FETCH_FINAPPSTATUS_REQUEST,
})

const finAppStatusSuccess = (data: any) => ({
  type: finAppStatusConstants.FETCH_FINAPPSTATUS_SUCCESS,
  payload: data,
})

export const fetchFinAppStatus = (opportunityId: string, finAppNumber: string) => {
  var completed = ['SUBMITTED', 'QUEUE', 'APPROVED', 'DECLINED']
  var incomplete = ['PENDING', 'OPEN']

  return (dispatch: any) => {
    let finAppStatus = {
      status: FinAppStatusValue.NONE,
      url: '',
      isFetching: false,
    }

    dispatch(finAppStatusRequest())

    if (finAppNumber == '0') return dispatch(finAppStatusSuccess(finAppStatus))
    else
      return FetchFinAppStatusService(
        opportunityId,
        finAppNumber,
        {},
        httpVerbConstants.HTTP_GET
      ).then(
        (data) => {
          if (data.status) {
            if (data.status.toUpperCase() == 'NOTSTARTED')
              finAppStatus = {
                status: FinAppStatusValue.NOTSTARTED,
                url: '',
                isFetching: false,
              }
            else if (completed.indexOf(data.status.toUpperCase()) != -1)
              finAppStatus = {
                status: FinAppStatusValue.COMPLETED,
                url: '',
                isFetching: false,
              }
            else if (incomplete.indexOf(data.status.toUpperCase()) != -1)
              finAppStatus = {
                status: FinAppStatusValue.STARTED,
                url: data.url,
                isFetching: false,
              }
          }

          dispatch(finAppStatusSuccess(finAppStatus))
        },
        (error) => {
          console.error(`Error: ${error}`)
          dispatch(finAppStatusSuccess(finAppStatus))
        }
      )
  }
}
